import type { V10InboxRow } from "../adapters/v10-fixtures.js";
import { v10ProjectRoute, v10ViewRoute } from "../adapters/v10-button-endpoints.js";
import { V10Btn, V10Kicker } from "../components/V10Primitives.js";
import type { V10Navigate } from "../routing/v10-routing.js";

export function V10ClientPortalInboxView({
  onNavigate,
  onOpenProject,
  rows,
}: {
  readonly onNavigate: V10Navigate;
  readonly onOpenProject: V10Navigate;
  readonly rows: readonly V10InboxRow[];
}) {
  return (
    <section className="v10-screen" aria-label="Client Portal inbox">
      <div className="v10-section-head v10-section-head--flush">
        <div>
          <V10Kicker>Client Portal</V10Kicker>
          <h2>Agency inbox for client requests.</h2>
          <p className="v10-muted">Every review opens the related Project Control Room.</p>
        </div>
        <V10Btn variant="line" onClick={() => onNavigate(v10ViewRoute("projects"))}>
          Open project list
        </V10Btn>
      </div>
      {rows.length === 0 ? <p className="v10-muted">No client requests right now.</p> : null}
      <ul className="v10-inbox-list">
        {rows.map((row) => (
          <li key={row.id} className="v10-inbox-row">
            <div>
              <strong>{row.clientName}</strong>
              <span className="v10-muted"> · {row.projectName}</span>
              <p>
                {row.requestLabel} — {row.status}
              </p>
              <span className="v10-age">{row.ageLabel}</span>
            </div>
            <V10Btn
              variant="primary"
              onClick={() =>
                onOpenProject(
                  v10ProjectRoute({ projectId: row.projectId, section: row.targetSection, mode: row.mode }),
                )
              }
            >
              {row.ctaLabel}
            </V10Btn>
          </li>
        ))}
      </ul>
    </section>
  );
}
